export default {
  "content": "<rect width=\"48\" height=\"48\" rx=\"24\" fill=\"#4141A2\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.478 30.924a.823.823 0 001.093-.402l1.976-4.28 1.635 1.634a.823.823 0 001.33-.237l1.892-4.1 1.643 2.19a.823.823 0 001.44-.233l2.47-7.412a.824.824 0 00-1.562-.52l-1.973 5.92-1.528-2.037a.824.824 0 00-1.407.15l-1.975 4.28-1.636-1.635a.824.824 0 00-1.33.237l-2.47 5.352a.824.824 0 00.402 1.093z\" fill=\"#fff\"/>",
  "attrs": {
    "width": "48",
    "height": "48",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};